

























































import Vue from 'vue';
import State from '../utils/state';

export default Vue.extend({
  name: 'Preview',
  props: {
    state: Symbol,
    loadingPrompt: String,
    allCanvas: Array as () => HTMLCanvasElement[],
  },
  data() {
    return {
      State,
    };
  },
  watch: {
    state(val: symbol) {
      if (val === State.FINISH) {
        document.querySelector('#preview')!.innerHTML = '';
        document.querySelector('#preview')!.append(...this.allCanvas);
      }
    },
  },
});
